import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=907b33be&scoped=true&lang=pug&"
import script from "./WarningDialog.vue?vue&type=script&lang=ts&"
export * from "./WarningDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907b33be",
  null
  
)

export default component.exports